const MatxLogo = () => {

  return (
    <img width={"35px"} height={"35px"} alt="logo" src='/assets/images/logos/logo.png'></img>
  );
};

export default MatxLogo;
